export type MerchantBranding = {
  logo?: string | null;
  icon?: string | null;
  hero?: string | null;
  primary_color?: string | null;
};

export type MerchantAddress = {
  country?: string | null;
  street_address?: string[] | null;
  post_code?: string | null;
  post_town?: string | null;
};

export type BusinessProfile = {
  name: string;
  branding?: MerchantBranding;
  code?: string;
  timezone: string;
  address?: MerchantAddress | null;
};

const cloudflareSecret = process.env.CLOUDFLARE_SECRET as string;

export const getMerchantBusinessProfile = async (merchantCode: string): Promise<BusinessProfile> => {
  const url = `${process.env.NEXT_PUBLIC_API_URL}/v1/merchants/${merchantCode}/business-profile`;
  try {
    const resp = await fetch(url, {
      cache: 'force-cache',
      headers: {
        'x-sumup-vercel-proof': cloudflareSecret,
      },
    });

    if (!resp.ok) {
      throw new Error(`HTTP error! status: ${resp.status}`);
    }

    return await resp.json();
  } catch (e) {
    console.error('Error fetching merchant business profile:', e);
    return {
      name: '',
      branding: {},
      timezone: 'UTC',
    };
  }
};
